<template>
    <v-snackbar
        :value="isSnackbarShown"
        @input="hideMessage"
    >
        {{ currentMessage.text }}
    </v-snackbar>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'
import {Watch} from 'vue-property-decorator'
import _ from 'lodash'
import {Message} from '@/store'

@Component
export default class Snackbars extends Vue
{
    isSnackbarShown = false
    currentMessage = {}

    protected get storedMessages() {
        return this.$store.state.messages
    }

    @Watch('storedMessages')
    onStoredMessagesChange(messages: Message[]) {
        const message = messages.find(m => m.show)
        if (message && !_.isEqual(message, this.currentMessage)) {
            this.currentMessage = message
            this.isSnackbarShown = true
        }
    }

    hideMessage() {
        this.isSnackbarShown = false
        this.$nextTick(() => {
            this.$store.commit('setMessageHidden', this.currentMessage)
        })
    }
}
</script>
